import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MoodRequest } from "../user-request.types";
import { MoodValue } from "@teammood/timeline";

@Component({
    selector: 'mood-request',
    templateUrl: './mood-request.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        CommonModule
    ]
})
export class MoodRequestComponent {

    @Input() requestedMood: MoodRequest;

    @Output() onCreate = new EventEmitter<MoodRequest>();

    constructor() {}

    createMood (moodValue: MoodValue){
        this.requestedMood.mood = moodValue;
        this.onCreate.emit(this.requestedMood);
    }

}